import { LegacyRef, forwardRef } from 'react';
import * as React from 'react';

interface CustomInputProps extends React.HTMLProps<HTMLInputElement> {
  id: string;
  label: string;
  description?: string;
  disabled?: boolean;
  error?: string;
}

const CustomInput = forwardRef(
  (props: CustomInputProps, ref: LegacyRef<HTMLInputElement>) => {
    const { id, label, disabled = false, description, error } = props;
    return (
      <div className='xpl-input w-full flex-col h-[68px] mb-[15px]'>
        <label htmlFor={id} className='text-sm font-medium'>
          {label}
        </label>
        {!!description && (
          <p
            className='font-sans text-base font-normal leading-4 tracking-normal text-left text-gray-700
'
          >
            {description}
          </p>
        )}
        <div
          className={`xpl-input-wrapper h-[44px] ${
            disabled && 'bg-gray-disabled'
          } ${error ? 'mb-0' : 'mb-5'}`}
        >
          <input
            ref={ref}
            disabled={disabled}
            placeholder={label}
            type='text'
            className={`appearance-none focus:outline-none focus:ring-0 pl-0`}
            style={{ color: '#6a6d7d' }}
            data-test-id={id}
            {...props}
          />
        </div>
        {error && <p className='text-red-500 leading-5 text-xs'>{error}</p>}
      </div>
    );
  },
);

export default CustomInput;
